<template>
  <div>
    <teleport to="#mapEnlargedTarget" :disabled="!fullScreen">
      <div class="relative" :class="{ fullScreen }" @keydown.esc.capture="closeFullScreen">
        <button ref="buttonRef" class="absolute right-0 z-50 p-3 m-3 bg-white rounded-full hover:bg-light-gray" @click="toggleFullScreen">
          <Expand class="w-8 h-8" />
        </button>
        <slot v-bind="{ fullScreen, openFullScreen, closeFullScreen, toggleFullScreen, buttonRef }" />
      </div>
    </teleport>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue';
import Expand from '@images/expand.svg?component';
import Scroll from '@/utils/scrolllock';

const fullScreen = ref(false);
const buttonRef = ref();
const openFullScreen = () => {
  Scroll.lock();
  fullScreen.value = true;
  nextTick(() => {
    buttonRef.value?.focus();
  });
};
const closeFullScreen = () => {
  fullScreen.value = false;
  Scroll.unlock();
};
const toggleFullScreen = () => {
  if (fullScreen.value) {
    closeFullScreen();
  } else {
    openFullScreen();
  }
};
</script>

<style lang="scss" scoped>
.fullScreen {
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 99999999;
}
</style>
